import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
  Badge,
  InputGroup,
  Pagination
} from 'react-bootstrap';
// import { FaPlus, FaTrash, FaPencilAlt, FaSearch } from 'react-icons/fa';
import { Plus, Trash, Pencil, Search, Share, Download } from "react-bootstrap-icons";
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import Header from '../../layouts/Header';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Vendors = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { loginEmail } = useSelector((state) => state.login);
  const email = loginEmail || localStorage.getItem("email");
  const [materialAccess, setMaterialAccess] = useState([]);

  console.log("Access :", access);

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("Vendors:")
      );
      setMaterialAccess(filteredAccess);
    }
  }, [access]);

  console.log("Material Access:", materialAccess);

  const accessToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [inputData, setInputData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    pincode: "",
    city: "",
    state: "",
    gstin: "",
  });
  const [countryList, setCountryList] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [vendorId, setVendorId] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
  const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [addNewOpenModal, setAddNewOpenModal] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
  const [errors, setErrors] = useState({});
  const [editErrors, setEditErrors] = useState({});

  const columns = [
    {
      Header: "SR.NO",
      accessor: "serialNumber",
      width: 50,
      // Cell: ({ row }) => <div className="fs-7">{row?.index + 1}</div>
    },
    {
      Header: "NAME",
      accessor: "name",
      width: 170,
      Cell: ({ value }) => <div className="fs-7">{value || "—"}</div>
    },
    {
      Header: "GST NO.",
      accessor: "gstin",
      width: 170,
      Cell: ({ value }) => (
        <div className="fs-7" style={{ textDecoration: "none" }}>
          {value || "—"}
        </div>
      )
    },
    {
      Header: "CONTACT",
      accessor: "contact",
      width: 210,
      Cell: ({ row }) => (
        <div className="fs-7">
          <span className="text-primary">{row.original.email || "—"}</span>
          <br />
          <span className="text-success">{row.original.phone || "—"}</span>
        </div>
      )
    },
    {
      Header: "ADDRESS",
      accessor: "address",
      width: 200,
      Cell: ({ value }) => <div className="fs-7 text-muted">{value || "—"}</div>
    },
    {
      Header: "CITY & PINCODE",
      accessor: "cityPincode",
      width: 140,
      Cell: ({ row }) => (
        <div className="fs-7">
          <span className="text-primary fw-normal">{row.original.city ? row.original.city.toUpperCase() : "—"}</span>
          <br />
          <span className="text-success fw-normal">{row.original.pincode || "—"}</span>
        </div>
      )
    },
    {
      Header: "STATE",
      accessor: "state",
      width: 120,
      Cell: ({ value }) => (
        <div className="fs-7">
          {value ? value.toUpperCase() : "—"}
        </div>
      )
    },
    ...(
      (materialAccess.includes("Vendors:update") || materialAccess.includes("Vendors:delete") || email === "contact@xpansecafe.com")
        ? [
          {
            Header: "ACTIONS",
            accessor: "actions",
            width: 165,
            Cell: ({ row }) => (
              <div className="d-flex justify-content-around align-items-center">
                {(materialAccess?.includes("Vendors:update") || email === 'contact@xpansecafe.com') && (
                  <>
                    <Button
                      variant="link"
                      onClick={() => handleEditModal(row.original)}
                      className="text-primary p-0 d-flex align-items-center gap-1 text-decoration-none"
                      style={{ fontSize: '12px' }}
                    >
                      <Pencil size={11} /> EDIT
                    </Button>
                    <span className="text-muted" style={{ fontSize: '12px' }}>|</span>
                  </>
                )}
                {(materialAccess?.includes("Vendors:delete") || email === 'contact@xpansecafe.com') && (
                  <Button
                    variant="link"
                    onClick={() => handleDeleteModal(row.original)}
                    className="text-danger p-0 d-flex align-items-center gap-1 text-decoration-none"
                    style={{ fontSize: '12px' }}
                  >
                    <Trash size={11} /> DELETE
                  </Button>
                )}
              </div>
            )
          }
        ] : []
    )
  ];

  const handleAddNewOpenModal = () => {
    setAddNewOpenModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prevState) => ({
      ...prevState,
      [name]: value,
      ...(name === "pincode" && value === "" ? { city: "", state: "" } : {}),
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!inputData.name.trim()) newErrors.name = "Name is required";
    if (!inputData.country) newErrors.country = "Country is required";
    if (!inputData.phone) newErrors.phone = "Phone is required";
    if (!inputData.pincode || inputData.pincode.length < 4) newErrors.pincode = "Valid pincode is required";
    if (!inputData.address.trim()) newErrors.address = "Address is required";
    if (!inputData.city) newErrors.city = "City is required";
    if (!inputData.state) newErrors.state = "State is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEditForm = () => {
    const newErrors = {};
    if (!editedData.name.trim()) newErrors.name = "Name is required";
    if (!editedData.country) newErrors.country = "Country is required";
    if (!editedData.phone) newErrors.phone = "Phone is required";
    if (!editedData.pincode || editedData.pincode.length < 4) newErrors.pincode = "Valid pincode is required";
    if (!editedData.address.trim()) newErrors.address = "Address is required";
    if (!editedData.city) newErrors.city = "City is required";
    if (!editedData.state) newErrors.state = "State is required";

    setEditErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      try {
        const headers = {
          Authorization: `Bearer ${accessToken}`,
        };
        const filteredData = { ...inputData };
        if (!filteredData.email) delete filteredData.email;
        if (!filteredData.gstin) delete filteredData.gstin;
        const response = await axiosInstance.post("vendor", filteredData, { headers });

        if (response?.data?.status === true) {
          toast.success(response?.data?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });

          getVendors();
          setInputData({
            name: "",
            email: "",
            phone: "",
            address: "",
            pincode: "",
            city: "",
            state: "",
            gstin: "",
            country: ""
          });
          setAddNewOpenModal(false);
        }
      } catch (error) {
        if (error?.response) {
          let errorMessage = '';
          if (error.response?.status === 406) {
            errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
          } else if (error.response?.status === 412) {
            errorMessage = error?.response?.data?.data?.message;
          } else if (error.response?.status === 500) {
            errorMessage = error?.response?.data?.error;
          }

          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const getVendors = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get("vendor", { headers });

      if (response?.data?.status === true) {
        const dataWithSerial = response?.data?.data?.vendors.map((item, index) => ({
          ...item,
          serialNumber: index + 1
        }));
        setVendors(dataWithSerial);
        setFilteredData(dataWithSerial);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } else if (error.response && error.response?.data?.status === 404) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  // Download Vendors
  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const headers = { 
        Authorization: `Bearer ${accessToken}`,
      };
      
      // Build URL with isDownload flag
      const url = `vendor?isDownload=true`;
      
      const response = await axiosInstance.get(url, { 
        headers,
        responseType: 'arraybuffer' // Use arraybuffer for better compatibility
      });
      
      // Check content type
      const contentType = response.headers['content-type'] || '';
      
      // If response is JSON (error case), parse it
      if (contentType.includes('application/json')) {
        const decoder = new TextDecoder('utf-8');
        const text = decoder.decode(new Uint8Array(response.data));
        const errorData = JSON.parse(text);
        toast.error(errorData.error || errorData.message || "Failed to download vendors");
        setDownloadLoading(false);
        return;
      }
      
      // Generate standardized filename with timestamp
      const date = new Date();
      const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`;
      
      // Create filename
      let filename = `Vendors List`;
      
      // Determine file extension based on content type
      if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        filename += '.xlsx';
      } else if (contentType.includes('application/vnd.ms-excel')) {
        filename += '.xls';
      } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
        filename += '.csv';
      } else {
        // Default to xlsx
        filename += '.xlsx';
      }
      
      // Create blob with proper MIME type
      const blob = new Blob([response.data], { 
        type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Verify file is not empty
      if (blob.size === 0) {
        toast.error("Downloaded file is empty");
        setDownloadLoading(false);
        return;
      }
      
      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 200);
      
      toast.success("Vendors downloaded successfully!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.error("Download error:", error);
      
      // Handle error responses
      if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
        try {
          const decoder = new TextDecoder('utf-8');
          const text = decoder.decode(new Uint8Array(error.response.data));
          const errorData = JSON.parse(text);
          toast.error(errorData.error || errorData.message || "Failed to download vendors");
        } catch {
          toast.error("Failed to download vendors. The server returned an unexpected response.");
        }
      } else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to download vendors. Please try again.");
      }
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleEditModal = async (data) => {
    setEditedData({
      _id: data?._id,
      name: data.name,
      email: data.email,
      address: data.address,
      phone: data.phone,
      country: data.country,
      pincode: data.pincode,
      city: data.city,
      state: data.state,
      gstin: data.gstin,
    });
    setVendorId(data._id);
    setOpenEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevState) => ({
      ...prevState,
      [name]: value,
      ...(name === "pincode" && value === "" ? { city: "", state: "" } : {}),
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (validateEditForm()) {
      setIsEditBtnLoading(true);
      try {
        const headers = {
          Authorization: `Bearer ${accessToken}`,
        };
        const filteredData = { ...editedData };
        if (!filteredData.email) delete filteredData.email;
        if (!filteredData.gstin) delete filteredData.gstin;
        const response = await axiosInstance.put("vendor", filteredData, { headers });
        if (response?.data?.status === true) {
          toast.success(response?.data?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
          getVendors();
          setOpenEditModal(false);
          getSingleVendorDetails(vendorId);
          setOpenViewModal(true);
          setVendorId("");
        }
      } catch (error) {
        if (error?.response) {
          let errorMessage = '';
          if (error.response?.status === 406) {
            errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
          } else if (error.response?.status === 412) {
            errorMessage = error?.response?.data?.data?.message;
          } else if (error.response?.status === 500) {
            errorMessage = error?.response?.data?.error;
          }

          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } finally {
        setIsEditBtnLoading(false);
      }
    }
  };

  const handleDeleteModal = async (data) => {
    setOpenDeleteModal(true);
    setVendorId(data?._id);
  };

  const handleDeleteVendor = async () => {
    setIsDeleteBtnLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const data = {
        _id: vendorId,
      };
      const response = await axiosInstance.delete(`vendor`, { data, headers });
      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getVendors();
        setOpenDeleteModal(false);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsDeleteBtnLoading(false);
    }
  };

  const handleOpenViewModal = (data) => {
    getSingleVendorDetails(data?._id);
    setOpenViewModal(true);
  };

  const getSingleVendorDetails = async (vendorId) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get(`vendor?_id=${vendorId}`, { headers });

      if (response?.data?.status === true) {
        setVendorDetails(response?.data?.data?.vendors);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getPostalCodeDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `https://api.zipcodestack.com/v1/search?codes=${inputData?.pincode}&country=${inputData?.country}&apikey=01J93RQKC9NH4A8K5G34RRT6GE`
      );
      const postalCode = inputData?.pincode;
      if (response?.data?.results?.[postalCode]?.length > 0) {
        const postOffice = response?.data?.results?.[postalCode]?.[0];
        setInputData((prevData) => ({
          ...prevData,
          city: postOffice?.city,
          state: postOffice?.state
        }))
      } else {
        toast.error("Country or pincode might be incorrect", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const getEditPostalCodeDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `https://api.zipcodestack.com/v1/search?codes=${editedData?.pincode}&country=${editedData?.country}&apikey=01J93RQKC9NH4A8K5G34RRT6GE`
      );
      const postalCode = editedData?.pincode;
      if (response?.data?.results?.[postalCode]?.length > 0) {
        const postOffice = response?.data?.results?.[postalCode]?.[0];
        setEditedData((prevData) => ({
          ...prevData,
          city: postOffice?.city,
          state: postOffice?.state
        }))
      } else {
        toast.error("Country or pincode might be incorrect", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const getCountryData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const response = await axiosInstance.get("country", { headers });
      setCountryList(response?.data?.data?.countries);
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  }

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  }

  const handleCloseAddModal = () => {
    setAddNewOpenModal(false);
    setInputData({
      name: "",
      email: "",
      phone: "",
      address: "",
      country: "",
      pincode: "",
      city: "",
      state: "",
      gstin: "",
    });
    setErrors({});
  }

  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  };

  const handleRowsPerPageChange = (e) => {
    setPagination({ page: 1, rowsPerPage: Number(e.target.value) });
  };

  const getPaginatedData = () => {
    const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
    const endIndex = startIndex + pagination.rowsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  // Generate pagination items with ellipsis for better UX
  const getPaginationItems = () => {
    const totalPages = Math.ceil(filteredData.length / pagination.rowsPerPage);
    const currentPage = pagination.page;
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  useEffect(() => {
    getVendors();
    getCountryData();
  }, []);

  useEffect(() => {
    const result = vendors.filter((item) => {
      return (
        item?.name?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.email?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.phone?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.address?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.pincode?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.city?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.state?.toLowerCase().match(searchText.toLowerCase()) ||
        item?.gstin?.toLowerCase().match(searchText.toLowerCase())
      );
    });
    setFilteredData(result);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, [searchText, vendors]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
        <Card className="shadow-sm border-0">
          <Card.Header className="bg-white border-0 py-3">
            <h5 className="mb-0 fw-semibold">
              <i className="bi bi-people me-2"></i>VENDORS MANAGEMENT
            </h5>
          </Card.Header>
          <hr className="my-0" />

          <Card.Body className="p-0">
            {/* Search and Table Section */}
            <div className=" p-3 bg-light rounded-3">
              <Row className="g-3 align-items-center mb-3">
                <Col md={6}>
                  <InputGroup size="sm">
                    <Form.Control
                      type="text"
                      placeholder="Search by vendor name..."
                      value={searchText}
                      onChange={handleSearchChange}
                      style={{ fontSize: '13px' }}
                    />
                    <Button variant="outline-secondary" size="sm">
                      <Search size={13} />
                    </Button>
                  </InputGroup>
                </Col>
                <Col md={6} className="text-end">
                  <div className="d-flex gap-2 justify-content-end">
                    {(materialAccess?.includes("Vendors:add") || email === 'contact@xpansecafe.com') && (
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={handleAddNewOpenModal}
                        className="d-flex align-items-center justify-content-center gap-1"
                        style={{ fontSize: '13px' }}
                      >
                        <Plus size={13} /> Add Vendor
                      </Button>
                    )}
                    {(materialAccess?.includes("Vendors:get") || email === 'contact@xpansecafe.com') && (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleDownload}
                        className="d-flex align-items-center justify-content-center gap-1"
                        style={{ fontSize: '13px' }}
                        disabled={downloadLoading}
                      >
                        {downloadLoading ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <Download size={13} />
                        )}
                        {downloadLoading ? " Downloading..." : " Download"}
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => navigate('/material/vendor-allocation')}
                      className="d-flex align-items-center justify-content-center gap-1"
                      style={{ fontSize: '13px' }}
                    >
                      <Share size={13} /> Allocate to Outlet
                    </Button>
                  </div>
                </Col>
              </Row>

              <div className="table-responsive">
                <Table striped bordered hover className="mb-0 align-middle" size="sm">
                  <thead className="bg-white">
                    <tr>
                      {columns?.map((column, idx) => (
                        <th key={idx} width={column.width} style={{ fontSize: '12px', fontWeight: '600', color: '#495057' }}>
                          {column.Header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {getPaginatedData().length > 0 ? (
                      getPaginatedData().map((row, rowIndex) => (
                        <tr key={rowIndex} style={{ fontSize: '13px' }}>
                          {columns.map((column, colIndex) => {
                            if (column.Cell) {
                              return (
                                <td key={colIndex}>
                                  {column.Cell({ row: { original: row, index: rowIndex }, value: row[column.accessor] })}
                                </td>
                              );
                            }
                            return (
                              <td key={colIndex} className="fw-light">
                                {row[column.accessor] || "—"}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={columns.length} className="text-center py-4">
                          <i className="bi bi-exclamation-circle fs-5 text-muted"></i>
                          <p className="mt-2 mb-0 text-muted" style={{ fontSize: '13px' }}>
                            No vendors found
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Pagination */}
              {filteredData.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="d-flex align-items-center">
                    <span className="me-2 text-muted" style={{ fontSize: '12px' }}>Show</span>
                    <Form.Select
                      size="sm"
                      style={{ width: '70px', fontSize: '12px' }}
                      value={pagination.rowsPerPage}
                      onChange={handleRowsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Form.Select>
                    <span className="ms-2 text-muted" style={{ fontSize: '12px' }}>entries</span>
                    <span className="ms-3 text-muted" style={{ fontSize: '12px' }}>
                      Showing {((pagination.page - 1) * pagination.rowsPerPage) + 1} to {Math.min(pagination.page * pagination.rowsPerPage, filteredData.length)} of {filteredData.length} entries
                    </span>
                  </div>

                  <Pagination size="sm" className="mb-0">
                    <Pagination.Prev
                      disabled={pagination.page === 1}
                      onClick={() => handlePageChange(pagination.page - 1)}
                    />

                    {getPaginationItems().map((item, index) => (
                      item === '...' ? (
                        <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                      ) : (
                        <Pagination.Item
                          key={item}
                          active={item === pagination.page}
                          onClick={() => handlePageChange(item)}
                        >
                          {item}
                        </Pagination.Item>
                      )
                    ))}

                    <Pagination.Next
                      disabled={pagination.page === Math.ceil(filteredData.length / pagination.rowsPerPage)}
                      onClick={() => handlePageChange(pagination.page + 1)}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>

        {/* Add Vendor Modal */}
        <Modal show={addNewOpenModal} onHide={handleCloseAddModal} centered size="lg">
          <Modal.Header closeButton className="py-3">
            <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Add Vendor</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body className="py-3">
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={inputData.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={inputData.email}
                      onChange={handleChange}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Phone <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Phone"
                      name="phone"
                      value={inputData.phone}
                      onChange={handleChange}
                      isInvalid={!!errors.phone}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Address <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Address"
                      name="address"
                      value={inputData.address}
                      onChange={handleChange}
                      isInvalid={!!errors.address}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Country <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="country"
                      value={inputData.country}
                      onChange={handleChange}
                      isInvalid={!!errors.country}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    >
                      <option value="">Select Country</option>
                      {countryList.map((country) => (
                        <option key={country._id} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.country}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Pincode <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Pincode"
                      name="pincode"
                      value={inputData.pincode}
                      onChange={handleChange}
                      onBlur={getPostalCodeDetails}
                      isInvalid={!!errors.pincode}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Text className="text-muted" style={{ fontSize: '11px' }}>Select country first</Form.Text>
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.pincode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      City <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="City"
                      name="city"
                      value={inputData.city}
                      onChange={handleChange}
                      isInvalid={!!errors.city}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      State <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="State"
                      name="state"
                      value={inputData.state}
                      onChange={handleChange}
                      isInvalid={!!errors.state}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {errors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>GSTIN</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="GSTIN"
                      name="gstin"
                      value={inputData.gstin}
                      onChange={handleChange}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="py-3">
              <Button variant="secondary" size="sm" onClick={handleCloseAddModal} style={{ fontSize: '13px' }}>
                Cancel
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={isLoading} style={{ fontSize: '13px' }}>
                {isLoading ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  "Add Vendor"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* Edit Vendor Modal */}
        <Modal show={openEditModal} onHide={() => setOpenEditModal(false)} centered size="lg">
          <Modal.Header closeButton className="py-3">
            <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>Edit Vendor</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleEditSubmit}>
            <Modal.Body className="py-3">
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={editedData.name}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.name}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={editedData.email}
                      onChange={handleEditChange}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Phone <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Phone"
                      name="phone"
                      value={editedData.phone}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.phone}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Address <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Address"
                      name="address"
                      value={editedData.address}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.address}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Country <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="country"
                      value={editedData.country}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.country}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    >
                      <option value="">Select Country</option>
                      {countryList.map((country) => (
                        <option key={country._id} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.country}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      Pincode <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Pincode"
                      name="pincode"
                      value={editedData.pincode}
                      onChange={handleEditChange}
                      onBlur={getEditPostalCodeDetails}
                      isInvalid={!!editErrors.pincode}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.pincode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      City <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="City"
                      name="city"
                      value={editedData.city}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.city}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>
                      State <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="State"
                      name="state"
                      value={editedData.state}
                      onChange={handleEditChange}
                      isInvalid={!!editErrors.state}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '12px' }}>
                      {editErrors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: '13px', fontWeight: '500' }}>GSTIN</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="GSTIN"
                      name="gstin"
                      value={editedData.gstin}
                      onChange={handleEditChange}
                      size="sm"
                      style={{ fontSize: '13px' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="py-3">
              <Button variant="secondary" size="sm" onClick={() => setOpenEditModal(false)} style={{ fontSize: '13px' }}>
                Cancel
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={isEditBtnLoading} style={{ fontSize: '13px' }}>
                {isEditBtnLoading ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* View Vendor Modal */}
        <Modal show={openViewModal} onHide={() => setOpenViewModal(false)} centered>
          <Modal.Header closeButton className="py-3">
            <Modal.Title style={{ fontSize: '16px', fontWeight: '600' }}>View Vendor Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-3">
            <Table striped bordered hover size="sm" className="mb-0">
              <tbody>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px', width: '120px' }}>Name</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.name || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>Email</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.email || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>Phone</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.phone || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>GSTIN</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.gstin || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>Address</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.address || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>City</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.city || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>State</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.state || "—"}</td>
                </tr>
                <tr>
                  <td className="fw-semibold" style={{ fontSize: '13px' }}>Pincode</td>
                  <td style={{ fontSize: '13px' }}>{vendorDetails?.pincode || "—"}</td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer className="py-3">
            <Button variant="warning" size="sm" onClick={() => setOpenViewModal(false)} style={{ fontSize: '13px' }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
          <Modal.Header closeButton className="py-3">
            <Modal.Title className="text-danger" style={{ fontSize: '16px', fontWeight: '600' }}>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-3" style={{ fontSize: '13px' }}>
            Are you sure you want to delete this vendor? This action cannot be undone.
          </Modal.Body>
          <Modal.Footer className="py-3">
            <Button variant="secondary" size="sm" onClick={handleCloseDeleteModal} style={{ fontSize: '13px' }}>
              Cancel
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={handleDeleteVendor}
              disabled={isDeleteBtnLoading}
              style={{ fontSize: '13px' }}
            >
              {isDeleteBtnLoading ? (
                <Spinner size="sm" animation="border" />
              ) : (
                "Delete"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default Vendors;